document.addEventListener("DOMContentLoaded", () => {
    const hash = decodeURI(window.location.hash.substring(1));
    const container = document.querySelector('.accordion-or-tabs__accordion-content');

    // If we have a hash and it's a valid value
    if (hash && container && container.querySelector(`.accordion-item[data-name*="${hash}"]`)) {
        // clear all
        const accordionItems = container.querySelectorAll('.accordion-item');
        accordionItems.forEach((item) => {
            item.querySelector('.accordion-button').classList.add('collapsed');
            item.querySelector('.accordion-button').setAttribute('aria-expanded', 'false');
            item.querySelector('.accordion-collapse').classList.remove('show');
        });

        // mark the targeted one
        const selectedAccordionItem = container.querySelector(`.accordion-item[data-name*="${hash}"]`);
        selectedAccordionItem.querySelector('.accordion-button').classList.remove('collapsed');
        selectedAccordionItem.querySelector('.accordion-button').setAttribute('aria-expanded', 'true');
        selectedAccordionItem.querySelector('.accordion-collapse').classList.add('show');


        const tabNavLinks = container.querySelectorAll('.accordion-or-tabs__accordion-tabs > ul > li > .nav-link');
        tabNavLinks.forEach((item) => {
            item.classList.remove('active');
        });
        const tabPanes = container.querySelectorAll('.tab-pane');
        tabPanes.forEach((item) => {
            item.classList.remove('active');
        });

        container.querySelector(`.accordion-or-tabs__accordion-tabs > ul > li[data-name*="${hash}"] > .nav-link`).classList.add('active');
        container.querySelector(`.tab-pane[data-name*="${hash}"]`).classList.add('active');
    }
});

